const roundMoney = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

export const calculateInvoiceRow = (item) => {
  const quantity = Number(item.quantity) || 0;
  const vatRate = Number(item.vatRate) || 0;
  const unitPrice = roundMoney(item.unitPrice);
  const rawAmount = roundMoney(unitPrice * quantity);
  const discount = item.discountType === 'amount'
    ? roundMoney(item.discountValue)
    : roundMoney(rawAmount * (Number(item.discountValue) || 0) / 100);
  const discounted = Math.max(0, roundMoney(rawAmount - discount));
  const net = item.isVatIncluded ? roundMoney(discounted / (1 + vatRate / 100)) : discounted;
  const vat = item.isVatIncluded ? roundMoney(discounted - net) : roundMoney(net * vatRate / 100);
  return { ...item, discountAmount: discount, totalAmount: net, vatAmount: vat, grandTotal: roundMoney(net + vat) };
};
